import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-tabs-switcher',
  templateUrl: './tabs-switcher.component.html',
  styleUrls: ['./tabs-switcher.component.scss'],
})
export class TabsSwitcherComponent {
  public active: number;

  constructor(private router: Router) {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((navEnd: NavigationEnd) => {
      if (navEnd.url.includes('location')) {
        this.active = 1;
      } else {
        this.active = 0;
      }
    });
  }

  overview() {
    this.active = 0;
  }

  location() {
    this.active = 1;
  }
}
